<script>
import "swiper/swiper-bundle.css";
import Swiper, { Autoplay } from "swiper";
Swiper.use([Autoplay]);

export default {
  name: "ClientsParameters",
  props: ["categories"],
  data() {
    const firstCategory = this.categories[0].id;
    return {
      activeTab: firstCategory,
    };
  },
  watch: {
    activeTab() {
      this.$nextTick(function () {
        this.createSwiper();
      });
    },
  },
  methods: {
    createSwiper() {
      this.swiper = new Swiper(this.$refs.swiper, {
        slidesPerView: "auto",
        //centeredSlides: true,
        freeMode: {
          enabled: true,
          momentum: false,
          momentumRatio: 0.0001,
          momentumVelocityRatio: 0.0001,
        },
        loop: true,
        speed: 6000,
        spaceBetween: 20,

        autoplay: {
          delay: 1,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        },
      });
    },
  },
  mounted() {
    this.createSwiper();
  },
};
</script>

<template>
  <div class="block-clients-partners">
    <div class="tabs">
      <template v-for="(category, index) in categories" :key="category.id">
        <div v-if="index != 0" class="separator"></div>
        <button
          type="button"
          class="tab"
          :class="{ active: activeTab == category.id }"
          @click="activeTab = category.id"
        >
          {{ category.title }}
        </button>
      </template>
    </div>
    <div ref="swiper" class="swiper-container" :key="activeTab">
      <div class="swiper-wrapper">
        <slot :name="'category' + activeTab" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-clients-partners {
  margin-bottom: 80px;

  @media screen and (max-width: 800px) {
    margin-bottom: 40px;
  }

  .tabs {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;

    @media screen and (max-width: 800px) {
      margin-bottom: 40px;
    }
  }

  .swiper-container {
    width: 100%;
  }

  .swiper-wrapper {
    transition-timing-function: linear;
  }

  .separator {
    height: 69px;
    width: 1px;
    background: #ced2d6;
    transform: rotate(30deg);
    margin: 0 20px 0 20px;

    @media screen and (max-width: 800px) {
      margin: 0 15px 0 15px;
      height: 40px;
    }
  }

  .tab {
    border: none;
    background: none;
    color: $color-brand-1;
    padding: 2px 0 2px 0;
    border-bottom: 2px dashed $color-brand-1;
    font-weight: 600;
    font-size: 30px;
    cursor: pointer;

    @media screen and (max-width: 800px) {
      font-size: 20px;
    }

    &.active {
      border-bottom: none;
      color: #94999f;
      cursor: default;
    }
  }
}
</style>
